function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.5361682,12.1692468 L22.8478635,3.30437136 C22.35823,2.89854288 21.6415272,2.89854288 21.1518937,3.30437136 L10.4640752,12.1692468 C9.91123187,12.6269946 9.84267346,13.4381752 10.3104266,13.9797562 C10.7781797,14.5208608 11.6057429,14.5889753 12.1590725,14.1297984 L12.3302254,13.9878537 L12.3302254,24.1978695 C12.3302254,24.6413276 12.6968427,25 13.1495227,25 L19.1821766,25 L19.1821766,16.1860913 L24.8175806,16.1860913 L24.8175806,25 L30.8502345,25 C31.3029145,25 31.670018,24.6413276 31.670018,24.1978695 L31.670018,13.9878537 L31.8416572,14.1297984 C32.0876895,14.3341416 32.389152,14.4346461 32.6876971,14.4346461 C33.0601492,14.4346461 33.4296839,14.280317 33.6893306,13.9797562 C34.15757,13.4381752 34.0885253,12.6269946 33.5361682,12.1692468",
  fill: "#FEFEFE"
}));

var SvgHomeoffice = function SvgHomeoffice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeoffice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeoffice.7054b7cd.svg";
export { ForwardRef as ReactComponent };